export const LOADING_PERIODICITY = "LOADING_PERIODICITY";
export const LOADING_PERIODICITY_LIST = "LOADING_PERIODICITY_LIST";
export const LOADING_PERIODICITYS = "LOADING_PERIODICITYS";
export const SAVE_LOADING_PERIODICITY = "SAVE_LOADING_PERIODICITY";
export const GET_PERIODICITY = "GET_PERIODICITY";
export const FORM_FAIL = "FORM_FAIL";
export const PERIODICITY_FAIL = "PERIODICITY_FAIL";
export const LOADING_PERIODICITY_BY_ID = "LOADING_PERIODICITY_BY_ID";
export const GET_PERIODICITY_BY_ID = "GET_PERIODICITY_BY_ID";
export const GET_PERIODICITYS_BY_ID = "GET_PERIODICITYS_BY_ID";
export const GET_PERIODICITY_LIST_BY_ID = "GET_PERIODICITY_LIST_BY_ID";
